import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

export enum SortTypeEnum {
  lightSort = 0,
  unLightSort = 1,
  dressSort = 2,
  unDressSort = 3,
}
export enum LightUpEnum {
  未点亮 = 0,
  点亮 = 1,
}
export enum OwnedEnum {
  未拥有 = 0,
  拥有 = 1,
}
export enum CataLogWearStatusEnum {
  未获得 = -1,
  已获得未穿戴 = 0,
  穿戴中 = 1,
}
export enum PageStatusEnum {
  主态 = 0,
  客态 = 1,
}

export const LevelConf = {
  // 传说
  50: {
    small: `${HostMaps.prod.img01}/img/png/id/310667996249`,
    big: `${HostMaps.prod.img01}/img/png/id/310667996621`,
  },
  // 精品
  40: {
    small: `${HostMaps.prod.img01}/img/png/id/310667997198`,
    big: `${HostMaps.prod.img01}/img/png/id/310667997379`,
  },
  // 史诗
  30: {
    small: `${HostMaps.prod.img01}/img/png/id/310667998092`,
    big: `${HostMaps.prod.img01}/img/png/id/310667998304`,
  },
  // 稀有
  20: {
    small: `${HostMaps.prod.img01}/img/png/id/310667998694`,
    big: `${HostMaps.prod.img01}/img/png/id/310667998918`,
  },
  // 普通
  10: {
    small: `${HostMaps.prod.img01}/img/png/id/310667999299`,
    big: `${HostMaps.prod.img01}/img/png/id/310667999512`,
  },
  // 无
  0: {
    small: `${HostMaps.prod.img01}/img/png/id/310667999299`,
    big: `${HostMaps.prod.img01}/img/png/id/310667999512`,
  },
}

export async function uploadImg(params) {
  const resp = await http.post('/live/misc/upload_img', {
    ...params,
    ...window.store.getState().env.deviceinfo,
  })
  return resp.data.data
}

export const homepage = createAsyncThunk(
  '/live/privilege/get_outfit_homepage',
  async (params: any, store: any) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      '/live/privilege/get_outfit_homepage',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  home: any
  base: {
    curSortInfo?: {
      type: SortTypeEnum
      idx: number
    }
    curPageStatus?: PageStatusEnum
  }
}

const initialState: InitialStateType = {
  home: {},
  base: {
    curSortInfo: {type: SortTypeEnum.lightSort, idx: 1},
  },
}

export const DressUpBookSlice = createSlice({
  name: 'Animal_Butterfly',
  initialState,
  reducers: {
    updateCurSortInfo: (state, action: PayloadAction<any>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          curSortInfo: action.payload,
        },
      })
    },
    updateCurPageStatus: (state, action: PayloadAction<PageStatusEnum>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          curPageStatus: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, {
        home: action.payload,
      })
    })
  },
})
export default DressUpBookSlice.reducer
export const DressUpBookActions = DressUpBookSlice.actions

export const useDressUpBookState = () => {
  const data = useSelector((state) => {
    return state.Animal_Butterfly
  })
  return data
}
